var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Modal } from '@app/Components/Modal/Modal';
import { DocumentCategoryDialogBody } from './Components/DocumentCategoryDialogBody/DocumentCategoryDialogBody';
export var DocumentCategoryDialog = /** @class */ (function (_super) {
    __extends(DocumentCategoryDialog, _super);
    function DocumentCategoryDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCategoryDialog.prototype.render = function () {
        var _a;
        var isOpen = (_a = this.props, _a.isOpen), project = _a.project, isProjectTerminatedOrCompleted = _a.isProjectTerminatedOrCompleted, onClose = _a.onClose;
        return (React.createElement(React.Fragment, null,
            React.createElement(Modal, { minWidth: "1000px", isOpen: isOpen, toggle: onClose, headerTitle: "Document category management", footerbuttons: this._getFooterButtons() },
                React.createElement(DocumentCategoryDialogBody, { project: project, isProjectTerminatedOrCompleted: isProjectTerminatedOrCompleted }))));
    };
    DocumentCategoryDialog.prototype._getFooterButtons = function () {
        return [
            {
                onClick: this.props.onClose,
                title: 'Close'
            }
        ];
    };
    DocumentCategoryDialog = __decorate([
        observer
    ], DocumentCategoryDialog);
    return DocumentCategoryDialog;
}(React.PureComponent));
